/**
 * Scroll Down Arrow Component
 * Positions arrow at the bottom of full-video-section and changes z-index when scrolled past
 */
export function scrolldownArrow() {
    const scrollArrow = document.querySelector('.scrolldown-arrow');
    const fullVideoSection = document.querySelector('.full-video-section');

    if (!scrollArrow || !fullVideoSection) return;

    // Function to update arrow position and z-index
    const updateArrow = () => {
        const videoSectionRect = fullVideoSection.getBoundingClientRect();
        const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
        
        // Calculate where the bottom of the full-video-section is relative to viewport
        const sectionBottomInViewport = videoSectionRect.bottom;
        // When section scrolls past, arrow stays at viewport bottom
        let arrowBottom;
        
        if (sectionBottomInViewport > 0 && sectionBottomInViewport < window.innerHeight) {
            // Section is visible, position arrow at section's bottom
            arrowBottom = window.innerHeight - sectionBottomInViewport + 60;
        } else if (sectionBottomInViewport <= 0) {
            // Section has scrolled past, keep arrow at fixed bottom
            arrowBottom = 60;
        } else {
            // Section hasn't reached viewport yet, position at viewport bottom
            arrowBottom = 60;
        }
        
        scrollArrow.style.bottom = `${arrowBottom}px`;
        
        // Check if we've scrolled past the bottom of the full-video-section
        const threshold = 50;
        const isPastVideoSection = sectionBottomInViewport < threshold;

        // Update z-index based on scroll position
        if (isPastVideoSection) {
            scrollArrow.style.zIndex = '0';
        } else {
            scrollArrow.style.zIndex = '5';
        }
    };

    // Use Intersection Observer for better performance
    const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: [0, 0.1, 0.5, 1]
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            // When the full-video-section is completely out of view (above viewport)
            if (entry.boundingClientRect.bottom < 0) {
                scrollArrow.style.zIndex = '0';
            } else {
                scrollArrow.style.zIndex = '5';
            }
        });
    }, observerOptions);

    observer.observe(fullVideoSection);

    // Listen to scroll events for position and z-index updates
    let ticking = false;
    const handleScroll = () => {
        if (!ticking) {
            window.requestAnimationFrame(() => {
                updateArrow();
                ticking = false;
            });
            ticking = true;
        }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', handleScroll, { passive: true });

    // Initial setup
    updateArrow();
}
